module.exports = __webpack_public_path__ + "media/theme/sample__nintendo-d73896cf.png";